import ebookManifest from '../ebook.json';

class EbookContent {
  constructor(ebookData) {
    this.cover = ebookData.cover;
    this.title = ebookData.title;
    this.pages = ebookData.pages;
    this.skin = ebookData.skin;
  }

  getAssetObjectByName(name) {
    const nameParts = name.split('_');
    const isNumber = /\d+/; // one or more digits

    if (nameParts.length === 2 && nameParts[1].match(isNumber)) {
      const [namePart, numberPart] = nameParts;
      if (namePart === 'narration') {
        return this.pages[numberPart - 1].content.narration;
      } else if (namePart === 'page') {
        return this.pages[numberPart - 1].image;
      }
    }

    if (name === 'cover') return this.cover;
    if (name === 'title') return this.title;

    const skinFile = this.skin.find(i => i.name === name);
    if (skinFile !== undefined) return skinFile;

    throw new Error(`File not found: Could not find: ${name}`);
  }

  getTextOfPage(pageNr) {
    return this.pageHasText(pageNr) ? this.pages[pageNr - 1].content.text : '';
  }

  pageHasNarration(pageNr) {
    return pageNr === 0 || this.pages[pageNr - 1].hasOwnProperty('content');
  }

  pageHasText(pageNr) {
    return pageNr > 0 && this.pages[pageNr - 1].hasOwnProperty('content');
  }
}

const ebook = new EbookContent(ebookManifest);
console.log(ebook);
export { ebook as default };
